import axios, { AxiosInstance } from "axios";

const BASE_URL = process.env.BASE_URL;

const AxiosClient: AxiosInstance = axios.create({
  baseURL: BASE_URL,
});

export const getHologramInfo = async (payload: { recaptchaToken: string; hologram: string }): Promise<any> =>
  (await AxiosClient.post(`/authinc/hologram`, payload)).data;
